import React, { ReactElement } from 'react';
import logo from '../imgs/logo-with-trademark.svg';
import './LogoPage.scss';

export default function LogoPage(props: Props) {
	return (
		<React.Fragment>
			<div className="full-height flex flex-justify-center flex-align-center">
				<div className="flex-item-static">
					<div className="logo-page__container">
						<div className="text-center">
							<img src={logo} style={{height: 40}} />
						</div>

						<div className="logo-page__divider"></div>

						{props.children}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}
interface Props {
    children: ReactElement;
}
